export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/chuangxin-2b5e614612ec4fda90da94c87e90b88c.png";